import {
  createContext,
  useContext,
  useState,
  ReactNode,
} from "react";
import type { FullPageErrorProps } from "../Components/CustomUi/CustomAlert";

interface GlobalErrorContextType {
  error: FullPageErrorProps | null;
  setError: (error: FullPageErrorProps) => void;
  clearError: () => void;
}

const GlobalErrorContext = createContext<GlobalErrorContextType | undefined>(
  undefined
);

const GLOBAL_ERROR_KEY = "globalError";

export const GlobalErrorProvider = ({ children }: { children: ReactNode }) => {
  const [error, setErrorState] = useState<FullPageErrorProps | null>(null);

  // Check for pending errors on mount (e.g., after page reload)
  // useEffect(() => {
  //   const storedError = localStorage.getItem(GLOBAL_ERROR_KEY);
  //   if (storedError) {
  //     try {
  //       const parsedError = JSON.parse(storedError);
  //       setErrorState(parsedError);
  //       // Clear from localStorage since we've restored it
  //       localStorage.removeItem(GLOBAL_ERROR_KEY);
  //     } catch (e) {
  //       // If parsing fails, just clear the invalid data
  //       localStorage.removeItem(GLOBAL_ERROR_KEY);
  //     }
  //   }
  // }, []);

  const setError = (error: FullPageErrorProps) => {
    setErrorState(error);
    // Store in localStorage to persist across page reloads
    localStorage.setItem(GLOBAL_ERROR_KEY, JSON.stringify(error));
  };

  const clearError = () => {
    setErrorState(null);
    localStorage.removeItem(GLOBAL_ERROR_KEY);
  };

  return (
    <GlobalErrorContext.Provider value={{ error, setError, clearError }}>
      {children}
    </GlobalErrorContext.Provider>
  );
};

export const useGlobalError = () => {
  const context = useContext(GlobalErrorContext);
  if (!context)
    throw new Error("useGlobalError must be used within a GlobalErrorProvider");
  return context;
};
